import React from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextAmount from 'components/text/TextAmount';
import TransactionKey from '../../components/TransactionKey';
import TextBoolean from 'components/text/TextBoolean';


const PaymentList = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }
  let payments = data.payments;
  return (
      <div className="calc-setting-table ">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="4" className="text-left calc-setting-table-header">Innborganir/afslættir/niðurfellingar</th>
          </tr>
          <tr>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Dagsetning</th>
            <th className="text-right">Drv.afsl.</th>
            <th className="text-right">Til kröfuhafa</th>
            <th className="text-right">Til lögmanns</th>            
            <th className="text-right">Samtals</th>
          </tr>
          </thead>
          <tbody>
          {payments.map(function(item,i){
            return(
            <tr key={i}>
              <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
              <td className="text-right"><TextDate value={item.paymentDate}/></td>
              <td className="text-right"><TextBoolean value={item.transactionKey.penaltyDiscount}/></td>              
              <td className="text-right"><TextAmount value={item.amount}/></td>
              <td className="text-right"><TextAmount value={item.lawyerAmount}/></td>
              <td className="text-right"><TextAmount value={item.totalAmount}/></td>                            
            </tr>);
          })}
          </tbody>
        </table>
      </div>
  );
};

PaymentList.propTypes = {
  data: PropTypes.object,
};

export default PaymentList;
